export const ReactionType = {
  Success: 0,
} as const;
export type ReactionType = (typeof ReactionType)[keyof typeof ReactionType];
